import { type PersistentStorageKey } from '../../../lib/storage';

/**
 * Длительность анимации появления/скрытия снежинок (в миллисекундах)
 * Используется как для CSS transition, так и для задержки в JS (чтобы обеспечить плавную анимацию при отключении)
 */
export const TRANSITION_DURATION_MS = 300;

/** Ключ для хранения состояния видимости снежинок в localStorage */
export const SNOWFLAKES_VISIBILITY_KEY: PersistentStorageKey = 'snowflakes-enabled';

/** Возможные символы снежинок */
export const SNOWFLAKE_SYMBOLS = ['❅', '❆', '❄', '✻', '✼', '❉'];
